import api from '../../../api';

export function uploadPrepaidPinCode(file) {
  return api.put(`prepaid-pincodes`, file);
}

export function uploadServiceablePinCode(file) {
  return api.put(`serviceable-pincodes`, file);
}

export function uploadBlockedCustomers(payload) {
  return api.put(`blocked-customers`, payload);
}

export function getServiceablePincode() {
  return api.get('serviceable-pincodes');
}

export function getPrepaidPinCode() {
  return api.get(`prepaid-pincodes`);
}

export function getBlockedCustomers() {
  return api.get('blocked-customers');
}
